export default "__VITE_ASSET__DOIuHY0w__"